import { render, staticRenderFns } from "./xieYi.vue?vue&type=template&id=436355cb&scoped=true&"
import script from "./xieYi.vue?vue&type=script&lang=js&"
export * from "./xieYi.vue?vue&type=script&lang=js&"
import style0 from "./xieYi.vue?vue&type=style&index=0&id=436355cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436355cb",
  null
  
)

export default component.exports